<template>
  <div class="flex min-h-screen items-center justify-center bg-gray-50 px-4 py-12 sm:px-6 lg:px-8">
    <div class="w-full max-w-md space-y-8">
      <div class="text-center">
        <img
          src="https://morgan-business-staging.web.app/_nuxt/New_CIM-PRO_White_BG.zPLAdPj4.jpg"
          alt="CIM-PRO Logo"
          class="mx-auto h-12 w-auto"
        >
        <h2 class="mt-6 text-3xl font-bold tracking-tight text-gray-900">
          {{ error?.statusCode || 'Error' }} - {{ error?.message || 'An error occurred' }}
        </h2>
        <p class="mt-2 text-sm text-gray-600">
          The page you're looking for doesn't exist or an error occurred.
        </p>
      </div>
      <div class="mt-8 space-y-6">
        <NuxtLink
          to="/"
          class="flex w-full justify-center rounded-md bg-primary px-3 py-2 text-sm font-semibold text-white shadow-sm hover:bg-primary-dark focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-primary"
        >
          Go back home
        </NuxtLink>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import type { NuxtError } from '#app'

const { error } = defineProps({
  error: Object as () => NuxtError,
})
</script>
